import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        const checkSession = () => {
            const token = localStorage.getItem('token');
            const expiry = localStorage.getItem('session_expiry');
            const now = Date.now();

            if (!token || !expiry || now > Number(expiry)) {
                setExpired(true);
                localStorage.clear();
            }
        };

        const interval = setInterval(checkSession, 1000);
        checkSession(); // also check immediately

        return () => clearInterval(interval);
    }, []);

    if (expired) return <Navigate to="/" replace />;
    return children;
};

export default ProtectedRoute;
